export interface IDashboardProjectsDataPieChart{
    name: string;
    value: number;
}

export interface IDashboardProject{
    id?: number;
	count: number;
    notStarted: number;
    inProgress: number;
    delayed: number;
    finished: number;
    started: number;
    nextToExpire: number;
    percentage: number;
    expectedPercentage: number;
    programTitle: string | null;
    group?: string;
    groupId?: number;
}

export const colorChart = [
	"var(--purple)",
	"var(--blue)",
	"var(--red)",
	"var(--green)",
	"var(--yellow)",
	"var(--default-color-font)"
];
